import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <h3>Viemask.com | by Michou</h3>
          <p>Votre boutique de produits bio de confiance</p>
        </div>
        
        <div className="footer-section">
          <h4>Liens rapides</h4>
          <Link to="/">Accueil</Link>
          <Link to="/shop">Boutique</Link>
          <Link to="/about">À propos</Link>
          <Link to="/contact">Contact</Link>
        </div>
        
        <div className="footer-section">
          <h4>Contact</h4>
          <p>Email: contact@viemask.com</p>
          <p>Tél: +213 558 87 28 54</p>
          <p>Tél: +213 542 18 09 56</p>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} viemask.com. Tous droits réservés.</p>
      </div>
    </footer>
  );
} 